import BaseServices from "lib/BaseServices";
import asModal from "lib/modal/asModal";
import promisify from "lib/promisify";
import Form from "lib/reauth/Form";
import {
    readCookie,
    setCookie,
} from "lib/reauth/utils";
import PropTypes from "prop-types";
import React from "react";
import InlineLoader from "views/InlineLoader";

const DbContext = React.createContext(undefined);

export function usePerms() {
    return React.useContext(DbContext).perms;
}

export function useOrgs() {
    return React.useContext(DbContext).orgs;
}

export function useArmusExists() {
    const orgs = useOrgs();
    return React.useMemo(() =>
        orgs.indexOf("armus") >= 0, [orgs]);
}

export function useImpls() {
    return React.useContext(DbContext).impls;
}

export function TestReauth({
                               triggerClose,
                           }) {
    const cookie = React.useMemo(readCookie, []);
    const [database, setDatabase] = React.useState({});
    React.useEffect(
        () => {
            promisify(BaseServices.getRequest("_/license_info"))
                .then(db => {
                    db.perms.unshift("ALL");
                    db.perms.push("NONE");
                    setDatabase(db);
                });
        },
        [],
    );

    function handleSave(spec) {
        setCookie(spec);
        window.location.reload();
    }

    return <div
        className={"reauth"}
    >
        <DbContext.Provider value={database}>
            {database.orgs
                ? <Form
                    cookie={cookie}
                    onSave={handleSave}
                    onCancel={triggerClose}
                />
                : <InlineLoader />}
        </DbContext.Provider>
    </div>;
}

TestReauth.propTypes = {
    triggerClose: PropTypes.func.isRequired,
};

export const BackboneTestReauth = asModal("Reauthorize")(TestReauth);



// WEBPACK FOOTER //
// ./app/lib/reauth/ReauthModule.js